module.exports = {
      id: "Checkmark-yellow-usage",
      viewBox: "0 0 20 20.604",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Checkmark-yellow-usage",
      toString: function () {
        return this.url;
      }
    }